import {IPropertyConverter} from '@mintdata/mint-kit/api/properties/PropertyConverter';
import {PropertyTypeConstructor} from '@mintdata/mint-kit/api/properties/PropertySpec';
import {ValidationResult} from '@mintdata/mint-kit/api/properties/ValidationResult';
import {AError} from '@mintdata/mint-kit/api/values/AError';

export class BaseFieldConverter<T> implements IPropertyConverter<T>
{
    public constructor(public readonly typeCtor:PropertyTypeConstructor<T>)
    {
    }

    public validate(value:string, isRequired:boolean = true):ValidationResult
    {
        throw new Error(`unsupported operation validate() in ${this.constructor['name']}`);
    }

    public validateValue(value:T, isRequired:boolean = true):ValidationResult
    {
        throw new Error(`unsupported operation validateValue() in ${this.constructor['name']}`);
    }

    public valueToString(value:T, isFocused:boolean = false):string
    {
        throw new Error(`unsupported operation valueToString() in ${this.constructor['name']}`);
    }

    public stringToValue(offsets:string, isRequired:boolean = true):T | AError
    {
        throw new Error(`unsupported operation stringToValue() in ${this.constructor['name']}`);
    }
}
